<template>
  <div class="page">

    <!--Title/Actions-->
    <div class="page-header flex-shrink-0 mb-3 bg-white border-bottom">
      <div class="d-flex justify-content-between align-items-center px-md-4 px-3">
        <h3 class="mb-0"><i class="fas fa-city"></i>&nbsp;Property Groups</h3>
        <div>
          <router-link class="btn btn-success" title="Create Group"
            :to="{ name: 'PropertyGroup', params: { id: 'new' } }"><i class="fas fa-plus"></i> Add</router-link>
        </div>
      </div>
    </div>

    <!--Search-->
    <div class="container-fluid px-md-4 px-3 py-3 bg-white border-bottom mb-3">
      <div class="row no-gutters">
        <div class="col-lg-4 col-md-6">
          <b-input-group>
            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
          </b-input-group>
        </div>
        <b-button :disabled="!filter" variant="link" @click="filter = ''">Clear</b-button>
      </div>
    </div>

    <!--Table-->
    <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3">
      <b-table id="properties-table" bordered class="mb-5 rg-table" :items="propertyGroupProvider"
        :fields="propertyGroupTableData.fields" no-local-filtering :filter="filter" no-local-sorting
        :sortDesc.sync="sortDesc" :busy.sync="isBusy">
        <template v-slot:cell(name)="data">
          <div class="emphasis">
            {{ data.item.name }}
          </div>
        </template>
        <template v-slot:cell(id)="data">
          <router-link class="btn btn-link" title="Edit Group"
            :to="{ name: 'PropertyGroup', params: { id: data.item.id } }"><i class="fas fa-edit"></i></router-link>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'PropertyGroupsManager',
  created () {
    this.fields = [
      { key: 'name', label: 'Name', sortable: true },
      { key: 'id', label: 'Actions' }]
  },
  components: {
  },
  data () {
    return {
      fields: [],
      isBusy: false,
      showArchived: false,
      sortBy: 'name',
      sortDirection: 'asc',
      filter: null,
      sortDesc: true,
      propertyGroups: []
    }
  },
  computed: {
    propertyGroupTableData () {
      var returnPropertyGroups = {
        fields: this.fields
      }
      console.log(
        'Property Group Table Data is: ' +
        JSON.stringify(returnPropertyGroups, null, 2)
      )
      return returnPropertyGroups
    }
  },
  methods: {
    ...mapActions('company', ['getPropertyGroups']),
    propertyGroupProvider (ctx) {
      this.isBusy = true
      console.log(
        'property table ctx is: ' +
        JSON.stringify(ctx, null, 2)
      )
      var request = { sortBy: ctx.sortBy, sortDirection: ctx.sortDesc ? 'desc' : 'asc', search: ctx.filter }

      // Must return a promise that resolves to an array of items
      return this.getPropertyGroups(request).then(r => {
        // Pluck the array of items off our axios response
        const items = r.data.propertyGroups
        console.log(
          'Returned Table Data is: ' +
          JSON.stringify(items, null, 2)
        )
        this.isBusy = false
        // Must return an array of items or an empty array if an error occurred
        return items || []
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setup/PropertyGroups.vue